import { Room } from "services/types/rooms.type";
import { formatClinic } from "./clinics.util";

export const formatRoomClinic = (room: Room) => {
  const { clinic, ...roomData } = room;
  return {
    ...roomData,
    clinic: formatClinic(clinic),
  };
};
